export { Search } from "./search.component";
